import * as React from 'react';
import * as automationLabels from '@Utils/facade/edgeTs/automationLabels';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import useDefineDevice from '@Utils/core/hooks/useDefineDevice';
import useLoadGeneratedNickname from '../../../hooks/useLoadGeneratedNickname';
import useLoadRandomAvatar from '../../../hooks/useLoadRandomAvatar';
import GeneratorContext from '../../../GeneratorContext';
import * as Styled from '../Nickname.styled';

const GenerateButton: React.FC = () => {
  const widgetGeneratorGlobalV3 = useWidget(WidgetId.GeneratorGlobalV3);
  const context = React.useContext(GeneratorContext);
  const { isMobileDevice } = useDefineDevice();

  const { loadNickname } = useLoadGeneratedNickname();
  const { loadAvatar } = useLoadRandomAvatar();

  const handleGenerate = () => {
    context.setIsCopied(false);

    if (isMobileDevice) {
      context.setIsGenerated(true);
    }

    if (!isMobileDevice) {
      const randomAvatar = loadAvatar();
      if (randomAvatar) {
        context.setAvatarInput(randomAvatar.images.avatar.src);
      }
    }

    loadNickname();
  };

  return (
    <Styled.GenerateButton
      {...automationLabels.getProps('generate.button')}
      onClick={handleGenerate}
    >
      {widgetGeneratorGlobalV3.strings.generateButton}
    </Styled.GenerateButton>
  );
};

export default GenerateButton;
